import React from 'react';
import { Grid, InputLabel, Select, MenuItem, TextField, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  inputGrid: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: '44px',
  },
  label: { width: '40%', display: 'flex', alignItems: 'center' },
  select: { width: '40%', maxHeight: '100%' },
  loadingSelect: { width: '40%', textAlign: 'center' },
  menuPaper: {
    maxHeight: '50%',
  },
});

const InputComponent = ({ advanceFilterLabel, children }) => {
  const classes = useStyles();

  return (
    <Grid item xs={4} className={classes.inputGrid}>
      <InputLabel className={classes.label}>{advanceFilterLabel}</InputLabel>
      {children}
    </Grid>
  );
};

const SelectComponent = ({ advanceFilter, selectedValue, handleAdvanceFiltersChange }) => {
  const classes = useStyles();

  return (
    <InputComponent advanceFilterLabel={advanceFilter.label}>
      {!advanceFilter.isLoading ? (
        <Select
          className={classes.select}
          name={advanceFilter.name}
          value={selectedValue || ''}
          multiple={advanceFilter.isMultiple}
          onChange={e => handleAdvanceFiltersChange(e.target.value)}
          MenuProps={{
            getContentAnchorEl: null,
            classes: { paper: classes.menuPaper },
          }}
        >
          {advanceFilter.isMultiple && <MenuItem value="">Any</MenuItem>}
          {advanceFilter.options.map(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Select className={classes.loadingSelect} name={advanceFilter.name} value={1} disabled>
          <MenuItem key={1} value={1}>
            {<CircularProgress style={{ width: '15px', height: '15px' }} />}
          </MenuItem>
        </Select>
      )}
    </InputComponent>
  );
};

const TextFieldComponent = ({ advanceFilter, selectedValue, handleAdvanceFiltersChange }) => {
  const classes = useStyles();

  return (
    <InputComponent advanceFilterLabel={advanceFilter.label}>
      <TextField
        className={classes.select}
        name={advanceFilter.name}
        value={selectedValue || ''}
        onChange={e => handleAdvanceFiltersChange(e.target.value)}
        placeholder={advanceFilter.label}
        error={advanceFilter.error !== ''}
        helperText={advanceFilter.error}
      />
    </InputComponent>
  );
};

export function RenderAdvanceFilters({ advanceFilter, selectedValue, handleAdvanceFiltersChange }) {
  switch (advanceFilter.type) {
    case 'select':
      return (
        <SelectComponent
          advanceFilter={advanceFilter}
          selectedValue={selectedValue}
          handleAdvanceFiltersChange={handleAdvanceFiltersChange}
        />
      );
    case 'textField':
      return (
        <TextFieldComponent
          advanceFilter={advanceFilter}
          selectedValue={selectedValue}
          handleAdvanceFiltersChange={handleAdvanceFiltersChange}
        />
      );
    default:
      return <React.Fragment />;
  }
}
